"use strict";
// tslint:disable
/**
 * Tunnel service on-premise APIs
 * Creates and manages premise CloudLink Gateway.
 *
 * OpenAPI spec version: 2017-09-01
 * Contact: cloudlink.support@mitel.io
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually. Blah blah blah
 */
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
const URLSearchParams = require('url-search-params');
const config_1 = require("../config");
const notifications_1 = require("../notifications");
const utils_1 = require("../utils");
const service_requester_1 = require("../service-requester");
// @ts-ignore
const separators = {
    csv: ',',
    ssv: ' ',
    tsv: '\t',
    pipes: '|',
};
/**
 * TunnelService
 * @class
 */
class TunnelService {
    /**
     * @constructor
     */
    constructor(params = {}) {
        this.topicFocusedNotify = new notifications_1.TopicFocusedNotify({
            notify: params.notify || config_1.Config.notifications,
            topic: 'platform-api-tunnel',
        });
        this.serviceRequester = params.serviceRequester || new service_requester_1.ServiceRequester(Object.assign({ service: 'Tunnel' }, params));
    }
    notifications() {
        return this.topicFocusedNotify;
    }
    /**
    * Used to set freeswitch configuration.
    * @summary Set freeswitch configuration
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @param {PostFreeswitchRequest} body Post freeswitch request object
    * @throws {RequiredError}
    */
    createFreeswitchConfig(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling createFreeswitchConfig.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling createFreeswitchConfig.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createFreeswitchConfig.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/settings/freeswitch`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to get freeswitch configuration.
    * @summary Get freeswitch configuration
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @throws {RequiredError}
    */
    getFreeswitchConfig(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getFreeswitchConfig.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getFreeswitchConfig.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/settings/freeswitch`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to set freeswitch trace.
    * @summary Set freeswitch trace
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @param {PutFreeswitchTraceRequest} body Put freeswitch trace request object
    * @throws {RequiredError}
    */
    sendFreeswitchTraceRequest(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling sendFreeswitchTraceRequest.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling sendFreeswitchTraceRequest.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling sendFreeswitchTraceRequest.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/settings/freeswitch/trace`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to create log.
    * @summary Create log
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @throws {RequiredError}
    */
    createLogRequest(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling createLogRequest.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling createLogRequest.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/logs`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to check log creation status.
    * @summary Check log creation status
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @throws {RequiredError}
    */
    getLogCreationStatus(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getLogCreationStatus.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getLogCreationStatus.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/logs/status`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to upload CloudLink Gateway logs to CloudLink.
    * @summary Get log
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @param {number} [expires] Number of seconds until the log signed url expires
    * @throws {RequiredError}
    */
    getLogRequest(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getLogRequest.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getLogRequest.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/logs`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.expires !== undefined) {
            query['expires'] = params.expires;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to check CloudLink Gateway logs uploading status.
    * @summary Check logs uploading status
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @param {string} logId Log identifier from GET /logs
    * @throws {RequiredError}
    */
    getLogUploadStatus(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getLogUploadStatus.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getLogUploadStatus.');
        }
        // verify required parameter 'logId' is not null or undefined
        if (params.logId === null || params.logId === undefined) {
            throw new utils_1.RequiredError('logId', 'Required parameter logId was null or undefined when calling getLogUploadStatus.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/logs/{logId}/status`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'logId'}}`, String(params.logId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to send maintenance request to CloudLink Gateway.
    * @summary Send maintenance request to CloudLink Gateway
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @param {PutMaintenanceRequest} body Put maintenance request object. One maintenance request at a time.
    * @throws {RequiredError}
    */
    sendMaintenanceRequest(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling sendMaintenanceRequest.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling sendMaintenanceRequest.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling sendMaintenanceRequest.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/settings/maintenance`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to get network settings.
    * @summary Get network settings
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @throws {RequiredError}
    */
    getNetworkSettings(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getNetworkSettings.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getNetworkSettings.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/settings/network`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to update network settings.
    * @summary Update network settings
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @param {PutNetworkRequest} body Put network request object
    * @throws {RequiredError}
    */
    updateNetworkSettings(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updateNetworkSettings.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling updateNetworkSettings.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateNetworkSettings.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/settings/network`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to set PBX sync schedule.
    * @summary Set PBX sync schedule
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @param {PostPbxSyncScheduleRequest} body Post PBX sync schedule object
    * @throws {RequiredError}
    */
    createPbxSyncSchedule(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling createPbxSyncSchedule.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling createPbxSyncSchedule.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createPbxSyncSchedule.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/pbxs/sync/schedule`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to get PBX sync status.
    * @summary Get PBX sync schedule
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @throws {RequiredError}
    */
    getPbxSyncSchedule(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getPbxSyncSchedule.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getPbxSyncSchedule.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/pbxs/sync/schedule`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to get PBX sync status.
    * @summary Get PBX sync status
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @throws {RequiredError}
    */
    getPbxSyncStatus(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getPbxSyncStatus.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getPbxSyncStatus.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/pbxs/sync`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to start PBX sync
    * @summary Start PBX synch
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @throws {RequiredError}
    */
    startPbxSync(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling startPbxSync.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling startPbxSync.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/pbxs/sync`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Adds a new pbx link to the system.
    * @summary Create a Pbxlink
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @param {PostPbxlinkRequest} body Post pbxlink request object
    * @throws {RequiredError}
    */
    createPbxlink(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling createPbxlink.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling createPbxlink.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createPbxlink.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/settings/pbxlinks`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes an individual PBX link.
    * @summary Delete a Pbxlink
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @param {string} pbxlinkId PBX link identifier
    * @throws {RequiredError}
    */
    deletePbxlink(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling deletePbxlink.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling deletePbxlink.');
        }
        // verify required parameter 'pbxlinkId' is not null or undefined
        if (params.pbxlinkId === null || params.pbxlinkId === undefined) {
            throw new utils_1.RequiredError('pbxlinkId', 'Required parameter pbxlinkId was null or undefined when calling deletePbxlink.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/settings/pbxlinks/{pbxlinkId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'pbxlinkId'}}`, String(params.pbxlinkId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets a PBX link by identifier
    * @summary Get a Pbxlink
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @param {string} pbxlinkId PBX link identifier
    * @throws {RequiredError}
    */
    getPbxlink(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getPbxlink.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getPbxlink.');
        }
        // verify required parameter 'pbxlinkId' is not null or undefined
        if (params.pbxlinkId === null || params.pbxlinkId === undefined) {
            throw new utils_1.RequiredError('pbxlinkId', 'Required parameter pbxlinkId was null or undefined when calling getPbxlink.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/settings/pbxlinks/{pbxlinkId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'pbxlinkId'}}`, String(params.pbxlinkId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the PBX links for the server.
    * @summary List PBX links
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @throws {RequiredError}
    */
    getPbxlinks(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getPbxlinks.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getPbxlinks.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/settings/pbxlinks`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to update a PBX link.
    * @summary Update a Pbxlink
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @param {string} pbxlinkId PBX link identifier
    * @param {PutPbxlinkRequest} body Put pbxlink request object
    * @throws {RequiredError}
    */
    updatePbxlink(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updatePbxlink.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling updatePbxlink.');
        }
        // verify required parameter 'pbxlinkId' is not null or undefined
        if (params.pbxlinkId === null || params.pbxlinkId === undefined) {
            throw new utils_1.RequiredError('pbxlinkId', 'Required parameter pbxlinkId was null or undefined when calling updatePbxlink.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updatePbxlink.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/settings/pbxlinks/{pbxlinkId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'pbxlinkId'}}`, String(params.pbxlinkId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to update a trunk group.
    * @summary Update a trunk group
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @param {string} pbxlinkId PBX link identifier
    * @param {string} trunkGroup Trunk group number
    * @param {PutLicenseRequest} body Put license request object
    * @throws {RequiredError}
    */
    updatePbxlinkLicense(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updatePbxlinkLicense.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling updatePbxlinkLicense.');
        }
        // verify required parameter 'pbxlinkId' is not null or undefined
        if (params.pbxlinkId === null || params.pbxlinkId === undefined) {
            throw new utils_1.RequiredError('pbxlinkId', 'Required parameter pbxlinkId was null or undefined when calling updatePbxlinkLicense.');
        }
        // verify required parameter 'trunkGroup' is not null or undefined
        if (params.trunkGroup === null || params.trunkGroup === undefined) {
            throw new utils_1.RequiredError('trunkGroup', 'Required parameter trunkGroup was null or undefined when calling updatePbxlinkLicense.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updatePbxlinkLicense.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/settings/pbxlinks/{pbxlinkId}/license/{trunkGroup}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'pbxlinkId'}}`, String(params.pbxlinkId))
            .replace(`{${'trunkGroup'}}`, String(params.trunkGroup));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to get PBX huntgroups.
    * @summary Get PBX huntgroups
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @param {string} pbxId PBX identifier
    * @param {number} [$Top] Number of items to include
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$Search] Search param
    * @param {string} [$Filter] Filter param
    * @param {string} [$Expand] Expand param
    * @throws {RequiredError}
    */
    getPbxHuntgroups(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getPbxHuntgroups.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getPbxHuntgroups.');
        }
        // verify required parameter 'pbxId' is not null or undefined
        if (params.pbxId === null || params.pbxId === undefined) {
            throw new utils_1.RequiredError('pbxId', 'Required parameter pbxId was null or undefined when calling getPbxHuntgroups.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/pbxs/{pbxId}/huntgroups`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'pbxId'}}`, String(params.pbxId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to get PBX phantoms.
    * @summary Get PBX phantoms
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @param {string} pbxId PBX identifier
    * @param {number} [$Top] Number of items to include
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$Search] Search param
    * @param {string} [$Filter] Filter param
    * @param {string} [$Expand] Expand param
    * @throws {RequiredError}
    */
    getPbxPhantoms(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getPbxPhantoms.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getPbxPhantoms.');
        }
        // verify required parameter 'pbxId' is not null or undefined
        if (params.pbxId === null || params.pbxId === undefined) {
            throw new utils_1.RequiredError('pbxId', 'Required parameter pbxId was null or undefined when calling getPbxPhantoms.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/pbxs/{pbxId}/phantoms`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'pbxId'}}`, String(params.pbxId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to get PBX trunks.
    * @summary Get PBX trunks
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @param {string} pbxId PBX identifier
    * @param {number} [$Top] Number of items to include
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$Search] Search param
    * @param {string} [$Filter] Filter param
    * @param {string} [$Expand] Expand param
    * @throws {RequiredError}
    */
    getPbxTrunks(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getPbxTrunks.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getPbxTrunks.');
        }
        // verify required parameter 'pbxId' is not null or undefined
        if (params.pbxId === null || params.pbxId === undefined) {
            throw new utils_1.RequiredError('pbxId', 'Required parameter pbxId was null or undefined when calling getPbxTrunks.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/pbxs/{pbxId}/trunks`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'pbxId'}}`, String(params.pbxId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to get PBX users.
    * @summary Get PBX users
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @param {string} pbxId PBX identifier
    * @param {number} [$Top] Number of items to include
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$Search] Search param
    * @param {string} [$Filter] Filter param
    * @param {string} [$Expand] Expand param
    * @throws {RequiredError}
    */
    getPbxUsers(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getPbxUsers.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getPbxUsers.');
        }
        // verify required parameter 'pbxId' is not null or undefined
        if (params.pbxId === null || params.pbxId === undefined) {
            throw new utils_1.RequiredError('pbxId', 'Required parameter pbxId was null or undefined when calling getPbxUsers.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/pbxs/{pbxId}/users`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'pbxId'}}`, String(params.pbxId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to get platform properties.
    * @summary Get platform properties
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @throws {RequiredError}
    */
    getPlatform(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getPlatform.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getPlatform.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/settings/platform`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Provides the specification defining the resources of the service API
    * @summary Get API spec
    * @throws {RequiredError}
    */
    getSpec(params) {
        const path = `/_spec`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to Cloudlink Gateway status.
    * @summary Get Cloudlink Gateway status
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @throws {RequiredError}
    */
    getCloudlinkStatus(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getCloudlinkStatus.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getCloudlinkStatus.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/status`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to get CL GW echo.
    * @summary Get echo
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @throws {RequiredError}
    */
    getEcho(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getEcho.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getEcho.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/webhooks/echo`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Provides the status of the microservice
    * @summary Get microservice status
    * @throws {RequiredError}
    */
    getStatus(params) {
        const path = `/_status`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to Cloudlink Gateway version.
    * @summary Get Cloudlink Gateway version
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @throws {RequiredError}
    */
    getSystemVersion(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getSystemVersion.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getSystemVersion.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/settings/version`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Remove all gateway configurations, including users, pbx link configurations, and account information. New onboarding can be done after using this function, without executing a factory reset.
    * @summary Delete customer data
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @throws {RequiredError}
    */
    deleteSystem(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling deleteSystem.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling deleteSystem.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/system`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to get initial network settings.
    * @summary Get initial network settings
    * @param {string} tunnelId Initial tunnel identifier
    * @throws {RequiredError}
    */
    getInitialNetworkSettings(params) {
        // verify required parameter 'tunnelId' is not null or undefined
        if (params.tunnelId === null || params.tunnelId === undefined) {
            throw new utils_1.RequiredError('tunnelId', 'Required parameter tunnelId was null or undefined when calling getInitialNetworkSettings.');
        }
        const path = `/tunnel/{tunnelId}/settings/network`
            .replace(`{${'tunnelId'}}`, String(params.tunnelId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to get initial platform properties.
    * @summary Get initial platform properties
    * @param {string} tunnelId Initial tunnel identifier
    * @throws {RequiredError}
    */
    getInitialPlatform(params) {
        // verify required parameter 'tunnelId' is not null or undefined
        if (params.tunnelId === null || params.tunnelId === undefined) {
            throw new utils_1.RequiredError('tunnelId', 'Required parameter tunnelId was null or undefined when calling getInitialPlatform.');
        }
        const path = `/tunnel/{tunnelId}/settings/platform`
            .replace(`{${'tunnelId'}}`, String(params.tunnelId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to change cloud link setting in CloudLink Gateway.
    * @summary Change cloud link settings
    * @param {string} tunnelId Initial tunnel identifier
    * @param {PutCloudlinkRequest} body Put Cloudlink object
    * @throws {RequiredError}
    */
    updateCloudTunnel(params) {
        // verify required parameter 'tunnelId' is not null or undefined
        if (params.tunnelId === null || params.tunnelId === undefined) {
            throw new utils_1.RequiredError('tunnelId', 'Required parameter tunnelId was null or undefined when calling updateCloudTunnel.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateCloudTunnel.');
        }
        const path = `/tunnel/{tunnelId}/settings/cloud`
            .replace(`{${'tunnelId'}}`, String(params.tunnelId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to get CloudLink Gateway upgrade schedule.
    * @summary Get CloudLink Gateway upgrade schedule
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @throws {RequiredError}
    */
    getUpgradeSchedule(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getUpgradeSchedule.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getUpgradeSchedule.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/settings/update`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to update CloudLink Gateway upgrade schedule.
    * @summary Update CloudLink Gateway upgrade schedule
    * @param {string} accountId Account identifier
    * @param {string} siteId Site identifier
    * @param {PutSettingsUpdateRequest} body Put settings update request object
    * @throws {RequiredError}
    */
    updateUpgradeSchedule(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updateUpgradeSchedule.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling updateUpgradeSchedule.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateUpgradeSchedule.');
        }
        const path = `/premise/accounts/{accountId}/sites/{siteId}/settings/update`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
}
exports.TunnelService = TunnelService;
